import ev from "../util/enumValue";

enum AnimationType {
    A_B = ev('A_B', 1),
    FADE = ev('FADE', 2),
    SLIDE_LEFT = ev('SLIDE_LEFT', 3),
    SLIDE_RIGHT = ev('SLIDE_RIGHT', 4),

    BOUNCE = ev("BOUNCE", 5),
    BOUNCE_LEFT = ev("BOUNCE_LEFT", 6),
    BOUNCE_RIGHT = ev("BOUNCE_RIGHT", 7),
    BOUNCE_UP = ev("BOUNCE_UP", 8),
    BOUNCE_DOWN = ev("BOUNCE_DOWN", 9),

    FADE_LEFT = ev("FADE_LEFT", 10),
    FADE_RIGHT = ev("FADE_RIGHT", 11),
    FADE_UP = ev("FADE_UP", 12),
    FADE_DOWN = ev("FADE_DOWN", 13),
    FADE_BIG_LEFT = ev("FADE_BIG_LEFT", 14),
    FADE_BIG_RIGHT = ev("FADE_BIG_RIGHT", 15),
    FADE_BIG_UP = ev("FADE_BIG_UP", 16),
    FADE_BIG_DOWN = ev("FADE_BIG_DOWN", 17),

    FADE_TOP_LEFT = ev("FADE_TOP_LEFT", 18),
    FADE_TOP_RIGHT = ev("FADE_TOP_RIGHT", 19),
    FADE_BOTTOM_LEFT = ev("FADE_BOTTOM_LEFT", 20),
    FADE_BOTTOM_RIGHT = ev("FADE_BOTTOM_RIGHT", 21),

    FLIP = ev("FLIP", 22),
    FLIP_VERTICAL = ev("FLIP_VERTICAL", 23),
    FLIP_HORIZONTAL = ev("FLIP_HORIZONTAL", 24),

    LIGHTSPEED_LEFT = ev("LIGHTSPEED_LEFT", 25),
    LIGHTSPEED_RIGHT = ev("LIGHTSPEED_RIGHT", 26),

    ROTATE = ev("ROTATE", 27),
    ROTATE_DOWN_LEFT = ev("ROTATE_DOWN_LEFT", 28),
    ROTATE_DOWN_RIGHT = ev("ROTATE_DOWN_RIGHT", 29),
    ROTATE_UP_LEFT = ev("ROTATE_UP_LEFT", 30),
    ROTATE_UP_RIGHT = ev("ROTATE_UP_RIGHT", 31),

    ZOOM = ev("ZOOM", 32),
    ZOOM_LEFT = ev("ZOOM_LEFT", 33),
    ZOOM_RIGHT = ev("ZOOM_RIGHT", 34),
    ZOOM_UP = ev("ZOOM_UP", 35),
    ZOOM_DOWN = ev("ZOOM_DOWN", 36),

    SLIDE_UP = ev("SLIDE_UP", 37), 
    SLIDE_DOWN = ev("SLIDE_DOWN", 38)
}

export default AnimationType;
